import { RiskFactorInfo } from '../risk-factor/risk-factor-info';
import { SelectPlanInfo } from '../select-plan/select-plan-info';

export class AuthMailInfo {
  // public 変数 ------------------------------------------------------------------------
  public mailAddress:		string 			= null;    // メールアドレス
  public applicationDate:	string			= null;	// 申込日
  public riskFactorInfo:	RiskFactorInfo	= null;    // リスクファクタ情報
  public selectPlanInfo:	SelectPlanInfo	= null;    // 選択プラン情報
  // ------------------------------------------------------------------------------------
}
